import shipments from './shipments';
import orders from './orders';
import locations from './locations';
import order_status from './order_status';

export default {
  namespaced: true,
  modules: {
    shipments,
    orders,
    locations,
    order_status,
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_md/index.js